
import Vue from 'vue';
import Close32 from '@carbon/icons-vue/es/close/32';
import { Release } from '@/libs/proof-approval/typings/common/Feature';
import printConfAPIs from '@/services/PrintConfigService';
import { useStore as useLangStore } from '@/stores/lang';
import { mapState } from 'pinia';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);

export default Vue.extend({
  name: 'WhatsNew',
  components: {
    Close32,
  },
  computed: {
    ...mapState(useLangStore, ['languageInUse']),
  },
  data() {
    return {
      releases: [] as Release[],
    };
  },
  watch: {
    languageInUse() {
      this.checkForNewFeatures();
    },
  },
  mounted() {
    window?.addEventListener('keydown', this.handleKeyPress);
    if (this.languageInUse !== 'none') {
      this.checkForNewFeatures();
    }
  },
  methods: {
    showModal() {
      document.body.classList.add('modal-open');
      this.$modal.show('whats-new-modal');
    },
    hideModal() {
      document.body.classList.remove('modal-open');
      this.$modal.hide('whats-new-modal');
    },
    checkForNewFeatures() {
      const w2pReleaseId = this.$cookies.get('w2p_release');
      if (w2pReleaseId === null) {
        this.$cookies.set('w2p_release', 0);
      } else {
        printConfAPIs
          .getNewFeatures(w2pReleaseId, this.languageInUse)
          .then((data) => {
            if (data.data.length > 0) {
              this.releases = data.data;
              this.$cookies.set('w2p_release', this.releases[0].id);
              this.showModal();
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    findTranslation(release: Release) {
      return release?.releaseNotes.find(
        (nt) => nt.language.code === this.languageInUse
      )?.text;
    },
    handleKeyPress(event: any) {
      if (event.key === 'Escape') {
        this.hideModal();
      }
    },
  },
});
